// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/forest-fire-restriction.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/forest-fire-restriction/forest-fire-restriction.js';

mount([g0]);
